<template>

  <div class="layout__container">

    <div class="layout__padding-20px">
      <div class="text__align-center text__colour-white layout__margin__bottom-25px">
        <div class="layout__padding-clear layout__width-50 layout__padding-20-0 layout__border__bottom-light-teal-1px">
          <h3 class="text__colour-teal">Modify Customer Record</h3>
          <!--<div class="layout__padding-20-0 text__colour-grey">(Enter the record details and click to Save Changes or Cancel)</div>-->
        </div>
      </div>

      <el-form
        :model="customer"
        ref="customer"
        :rules="rules"
        class="layout__position-left layout__width-100"
      >

        <div class="layout__overflow-hidden ">
          <div class="layout__border__all-1px-dotted-cdcfd1 layout__overflow-hidden layout__padding-20px">
            <div class="text__colour-teal layout__padding-10px-0">
              Branch Information
            </div>
            <div class="component__forms-4 colour__background-light-grey">
              <div class="layout__padding-0-20">
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Branch Code<span
                    class="text__colour-red"
                  >*</span></p>
                  <p
                    class=""
                    v-if="this.customer.ref"
                  >{{ this.customer.ref }}</p>
                  <p
                    class=""
                    v-else
                  >-</p>
                </div>

                <el-form-item
                  prop="branchName"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Branch Name</div>
                  <el-input
                    autofocus
                    v-model="customer.branchName"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="status"
                  class="component__forms__fields"
                >
                  <p class="component__forms__fields__labels">Status</p>
                  <p
                    v-if="this.customer.status"
                    class="component__form__values"
                  >
                    {{ this.customer.status }}</p>
                  <p
                    v-else
                    class="component__form__values"
                  >-</p>
                </el-form-item>
                <el-form-item
                  prop="customerName"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Customer<span
                    class="text__colour-red"
                  >*</span>
                  </div>
                  <el-input v-model="customer.customerName">
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="custType"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Customer type</div>
                  <el-select
                    v-model="customer.custType"
                    class="layout__position-left"
                  >
                    <el-option
                      v-for="customerType in customerTypes"
                      :key="customerType.name"
                      :label="customerType.name"
                      :value="customerType.value"
                    />
                  </el-select>
                </el-form-item>
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Head Office</p>
                  <p
                    v-if="this.customer.parentRef"
                    class=""
                  >
                    {{ this.customer.parentRef }}</p>
                  <p
                    v-else
                    class=""
                  >-</p>
                </div>
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Brand</p>
                  <p
                    v-if="this.customer.brand"
                    class=""
                  >{{ this.customer.brand }}</p>
                  <p
                    v-else
                    class=""
                  >-</p>
                </div>
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Created</p>
                  <p
                    class=""
                    v-if="this.customer"
                  >{{ formatDateDDMMYYYYCreated(this.customer) }}</p>
                </div>
              </div>
            </div>
            <div class="component__forms-4">
              <div class="layout__padding-0-10">
                <el-form-item
                  prop="address1"
                  class=""
                >
                  <div class="component__forms__fields__labels">Branch Address<span
                    class="text__colour-red"
                  >*</span></div>
                  <el-input
                    v-model="customer.address1"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="address2">
                  <el-input
                    v-model="customer.address2"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="address3">
                  <el-input
                    v-model="customer.address3"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="town"
                  clas
                >
                  <!--<div class="component__forms__fields__labels">Town</div>-->
                  <el-input
                    v-model="customer.town"
                    class="layout__position-left"
                    placeholder="Town"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="county"
                  class="component__forms__fields"
                >
                  <!--<div class="component__forms__fields__labels">County</div>-->
                  <el-input
                    v-model="customer.county"
                    class="layout__position-left"
                    placeholder="County"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="postcode"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Postcode<span
                    class="text__colour-red"
                  >*</span>
                  </div>
                  <el-input
                    v-model="customer.postcode"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="box"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">DX Depot</div>
                  <el-input
                    v-model="customer.box"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="companyRegistrationNumber"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Company Registration Number</div>
                  <el-input
                    v-model="customer.companyRegistrationNumber"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="component__forms-4">
              <div class="layout__padding-0-10">
                <el-form-item prop="invoiceAddress">
                  <span class="component__forms__fields__labels">Accounts Name and Address</span>
                  <el-input
                    type="textarea"
                    :rows="5"
                    :disabled="true"
                    v-model="customer.invoiceAddress"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="contact"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Accounts Contact</div>
                  <el-input
                    v-model="customer.accountsContact"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="email">
                  <div class="component__forms__fields__labels">Invoice Email Address</div>
                  <el-input
                    v-model="customer.accountsEmail"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  prop="telNo"
                  class="component__forms__fields"
                >
                  <div class="component__forms__fields__labels">Accounts Telephone No</div>
                  <el-input
                    v-model="customer.accountsTelNo"
                    class="layout__position-left"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="component__forms-4">
              <div class="layout__padding-0-10">
                <el-form-item
                  prop="netsuiteId"
                  class=""
                >
                  <p class="component__forms__fields__labels">NetSuite ID</p>
                  <p v-if="this.customer.netsuiteId">{{ this.customer.netsuiteId }}</p>
                  <p v-else>-</p>
                </el-form-item>
                <!--<el-form-item prop="salesForceId" class="">-->
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Salesforce ID</p>
                  <p
                    v-if="this.customer.salesForceId"
                    class=""
                  >{{ this.customer.salesForceId }}</p>
                  <p
                    v-else
                    class=""
                  >-</p>
                </div>
                <!--</el-form-item>-->
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Territory</p>
                  <p
                    class=""
                    v-if="this.customer.territory"
                  >{{ this.customer.territory }}</p>
                  <p
                    class=""
                    v-else
                  >-</p>
                </div>
                <el-form-item
                  prop="software"
                  class="component__forms__fields__labels"
                >
                  <div class="component__forms__fields__labels">Software</div>
                  <el-select
                    v-model="customer.software"
                    placeholder="Select Software"
                    clearable="true"
                  >
                    <el-option
                      v-for="software in ravensworth.softwareType.options"
                      :key="software.id"
                      :label="software.text"
                      :value="software.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!--<el-form-item prop="type">-->
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Type</p>
                  <p v-if="this.customer.type">{{ this.customer.type }}</p>
                  <p v-else>-</p>
                </div>

                <!--<el-form-item prop="minQty">-->
                <div class="layout__padding-10px-0">
                  <p class="component__forms__fields__labels">Min Qty</p>
                  <p v-if="this.customer.minQty">{{ this.customer.minQty }}</p>
                  <p v-else>-</p>
                </div>
                <!--</el-form-item>-->
              </div>
            </div>
          </div>
        </div>

        <div class="layout__display-block layout__overflow-hidden layout__padding-20-0">
          <div class="component__forms-3">


            <div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">
              <div class="text__colour-teal layout__padding-10px-0">
                General Branch Contact Details
              </div>
              <el-form-item
                prop="marketingContact"
                class="component__forms__fields"
              >
                <div class="component__forms__fields__labels">Branch Contact</div>
                <el-input
                  v-model="customer.contact"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="marketingTelNo"
                class="component__forms__fields"
              >
                <div class="component__forms__fields__labels">Branch Telephone</div>
                <el-input
                  v-model="customer.telNo"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="marketingEmail"
                class="component__forms__fields"
              >
                <div class="component__forms__fields__labels">Branch Email</div>
                <el-input
                  v-model="customer.email"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
            </div>

          </div>
          <!--<div class="component__forms-3">-->
          <!--<div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">-->
          <!--<div class="text__colour-teal layout__padding-10px-0">-->
          <!--Sales Contact-->
          <!--</div>-->
          <!--<el-form-item prop="salesContact" class="component__forms__fields">-->
          <!--<div class="component__forms__fields__labels">Sales Contact</div>-->
          <!--<el-input v-model="customer.salesContact" class="layout__position-left">-->
          <!--</el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item prop="salesTelephone" class="component__forms__fields">-->
          <!--<div class="component__forms__fields__labels">Sales Telephone</div>-->
          <!--<el-input v-model="customer.salesTelephone" class="layout__position-left">-->
          <!--</el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item prop="salesEmail" class="component__forms__fields">-->
          <!--<div class="component__forms__fields__labels">Sales Email</div>-->
          <!--<el-input v-model="customer.marketingEmail" class="layout__position-left">-->
          <!--</el-input>-->
          <!--</el-form-item>-->
          <!--</div>-->
          <!--</div>-->
          <div class="component__forms-3">


            <div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">
              <div class="text__colour-teal layout__padding-10px-0">
                Decision Maker Contact (Marketing)
              </div>
              <el-form-item
                prop="accountsContact"
                class="component__forms__fields"
              >
                <div class="component__forms__fields__labels">Decision Maker Contact</div>
                <el-input
                  v-model="customer.marketingContact"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="accountsTelephone"
                class="component__forms__fields"
              >
                <div class="component__forms__fields__labels">Decision Maker Telephone</div>
                <el-input
                  v-model="customer.marketingTelNo"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="accountsEmail"
                class="component__forms__fields"
              >
                <div class="component__forms__fields__labels">Decision Maker Email</div>
                <el-input
                  v-model="customer.marketingEmail"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="component__forms-3">
            <div class="layout__overflow-hidden layout__padding-20px layout__border__all-1px-dotted-cdcfd1">
              <div class="text__colour-teal layout__padding-10px-0">
                Account Notes
              </div>
              <el-form-item
                prop="notes"
                class=""
              >
                <el-input
                  type="textarea"
                  :rows="8"
                  v-model="customer.notes"
                  class="layout__position-left"
                >
                </el-input>
              </el-form-item>
              <p class="layout__padding__top-10px">Last Modified: {{ this.modified }}</p>
            </div>
          </div>
        </div>
      </el-form>

      <div class="layout__padding-clear text__align-center layout__padding-20-0 colour__background-light-grey">
        <el-button
          class="button-red button__base__admin layout__margin__right-20px"
          v-on:click="updateCustomer('customer')"
        >Save Changes
        </el-button>
        <el-button
          class="button-teal button__base__admin layout__margin__right-20px"
          v-on:click="cancelChanges()"
        >Cancel Changes
        </el-button>
        <el-button
          class="button-red button__base__admin"
          disabled="true"
        >Delete
        </el-button>
        <div id="message"></div>
      </div>

    </div>
  </div>

</template>

<script>

import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';

export default {
  name: 'createCustomers',

  mixins: [axios, csvDownloadHelper, dataFormatter, backing],

  PAYG_NAME: 'ONLINE ONLY',
  ACCOUNT_NAME: 'ACCOUNT',

  props: {
    customer: {},
  },

  data() {
    return {
      modified: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
      softwares: [],
      rules: {
        customerName: [{
          required: true,
          message: 'customer name required',
          trigger: 'blur',
        }],
        address1: [{
          required: true,
          message: 'address required',
          trigger: 'blur',
        }],
        postcode: [{
          required: true,
          message: 'postcode required',
          trigger: 'blur',
        }],
      },

      customerTypes: [],
    };
  },

  async created() {
    this.isUserAuthorised();

    if (typeof this.customer === 'undefined') {
      if (window.sessionStorage.getItem('_customerDetails') !== null) {
        this.customer = JSON.parse(window.sessionStorage.getItem('_customerDetails'));
      }
    } else {
      window.sessionStorage.setItem('_customerDetails', JSON.stringify(this.customer));
    }

    await this.getCustomerTypes();
  },

  methods: {
    updateCustomer(customer) {
      this.$refs[customer].validate((valid) => {
        if (valid) {
          console.log('done post');

          const createPrices = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/Update`;

          console.log(this.customer);

          // this.customer.software = null
          const loading = this.$loading({
            lock: true,
            text: 'Saving Changes...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });

          Axios.put(createPrices, this.customer, this.returnHeaderUsingToken())
            .then(response => {
              console.log(response);
              this.customer = response.data.result;
              window.sessionStorage.setItem('_customerDetails', JSON.stringify(this.customer));
              document.getElementById('message').innerText = 'Customer Successfully Updated';
              document.getElementById('message').classList.add('component__message-base', 'component__message-success', 'layout__display-block');
              // this.priceCodes = response.data.value
              loading.close();
            })
            .catch(error => {
              document.getElementById('message').innerText = 'There was a problem updating the customer - please try again';
              document.getElementById('message').classList.add('component__message-base', 'component__message-fail', 'layout__display-block');
              loading.close();
            });

          // todo the axios call
          // todo take the updated order and put in the order object

        } else {
          return false;
        }
      });
    },

    cancelChanges() {
      this.customer = JSON.parse(window.sessionStorage.getItem('_customerDetails'));
    },

    async getCustomerTypes() {
      const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/v1/dynamicquery/GetCustomerTypes`;

      const response = await Axios.get(url, this.returnHeaderUsingToken());

      this.customerTypes = response.data
        .map((customerType) => {
          return {
            name: customerType.cust_type === null ? this.$options.PAYG_NAME : customerType.cust_type,
            value: customerType.cust_type,
          };
        });

      this.reorderCustomerTypes();
    },

    reorderCustomerTypes() {
      const firstItems = [
        this.$options.ACCOUNT_NAME,
        this.$options.PAYG_NAME,
      ];

      this.customerTypes.forEach((customerType, index) => {
        if (firstItems.includes(customerType.name)) {
          const newIndex = firstItems.indexOf(customerType.name);

          const replacedItem = this.customerTypes[newIndex];

          this.customerTypes[newIndex] = customerType;
          this.customerTypes[index] = replacedItem;
        }
      });
    },
  },
};
</script>